import types from "../types/types";

export const spinnerLoaded = (loading) => ({
    type: types.spinnerLoaded,
    payload: loading,
});